import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Modal } from '@storable/canaveral-components';
import { object, string } from 'yup';
import Button from '../../../../../../modules/react/components/stateless/Button';
import formatInitialValues from '../../../../../../admin/lib/formatInitialValues';
import withForm from '../../../../../../admin/hocs/withForm';
import FormFieldText from '../../../../../../admin/components/FormFieldText';

const propTypes = {
  dirty: PropTypes.bool.isRequired,
  hideSettingsModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  site: PropTypes.shape({
    blogSettings: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  show: PropTypes.bool.isRequired,
};

const defaultProps = {};

const initialValues = {
  blogSettings: {
    title: '',
  },
};

const validationSchema = object().shape({
  blogSettings: object().shape({
    title: string().required('Blog title is required'),
  }),
});

const SettingsModal = ({
  dirty,
  hideSettingsModal,
  handleSubmit,
  isValid,
  show,
}) => (
  <Modal
    show={show}
    onDismiss={hideSettingsModal}
    aria-labelledby="blog-list-editor"
  >
    <Modal.Header>
      <Modal.Title id="blogSettings">Blog Settings</Modal.Title>
    </Modal.Header>
    <form onSubmit={handleSubmit}>
      <Modal.Body>
        <FormFieldText
          name="blogSettings.title"
          label="Blog Title"
          required
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="default"
          onClick={hideSettingsModal}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          disabled={!dirty || !isValid}
          onClick={handleSubmit}
          type="submit"
        >
          Submit
        </Button>
      </Modal.Footer>
    </form>
  </Modal>
);

SettingsModal.propTypes = propTypes;
SettingsModal.defaultProps = defaultProps;

SettingsModal.fragments = {
  currentSite: gql`
    fragment CurrentSiteBlogDataSettingsModal on Site {
      blogSettings {
        title
      }
    }
  `,
};

export default withForm({
  mapPropsToValues: props => formatInitialValues(initialValues, props.site),
  validationSchema,
  handleSubmit: (updatedSite, formikBag) => formikBag.props.onSubmit(updatedSite),
})(SettingsModal);
